import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

type UseGetProjectCommentsProps = {
  projectId: string
}

export const useGetProjectComments = ({
  projectId,
}: UseGetProjectCommentsProps) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['project-comments', projectId],
    queryFn: () => projectService.projectComments.getComments(projectId),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar os comentários do projeto',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      projectComments: data,
      isLoadingGetProjectComments: isLoading,
      refetchProjectComments: refetch,
    }
  }

  return {
    projectComments: [],
    isLoadingGetProjectComments: isLoading,
    refetchProjectComments: refetch,
  }
}
